"use client";

import dynamic from "next/dynamic";

import { Block } from "../Block";

const TechnologyLayersGraphicUI = dynamic(() =>
  import("@ui/components/core/TechnologyLayersGraphic/TechnologyLayersGraphicUI").then(
    mod => mod.TechnologyLayersGraphicUI,
  ),
);

export interface GraphicsLayersWrapperProps {
  slides?: Array<{ title: string; description: string; id?: string | null }> | null;
}

export const GraphicsLayersWrapper = ({ slides = [] }: GraphicsLayersWrapperProps) => {
  // Transform CMS data structure to UI component format
  const transformedSlides =
    slides?.map(slide => ({
      title: slide.title ?? "",
      description: slide.description ?? "",
    })) ?? [];

  // Ensure we always have 3 slides (pad with empty if needed)
  const paddedSlides = [
    ...transformedSlides,
    ...Array(Math.max(0, 3 - transformedSlides.length)).fill({ title: "", description: "" }),
  ].slice(0, 3);

  return (
    <Block name='Graphics - Layers'>
      <TechnologyLayersGraphicUI slides={paddedSlides} />
    </Block>
  );
};
